/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Dispatch, SetStateAction, useState } from 'react';
import FadeIn from 'legacy/common/components/transition/FadeIn';
import { MdArrowBack } from 'react-icons/md';
import { Waiver } from 'legacy/components/pages/Events/EventForm/Groups/Waiver/EventWaiverModal';
import ReactMarkdown from 'react-markdown';
import { textWithMarkdown } from '../../../util/urlMatching';
import classnames from 'classnames';

interface GuestWaiverProps {
  onGoBack(): void;
  waivers: Waiver[];
  setCheckedWaiverCount: Dispatch<SetStateAction<number>>;
  headerStyle?: string;
  waiverStyle?: string;
}

const linkRenderer = (props) => (
  <a
    href={props.href}
    target="_blank"
    className="text-blue-600 underline"
    rel="noreferrer"
  >
    {props.children}
  </a>
);

const GuestWaiver = ({
  onGoBack,
  waivers,
  setCheckedWaiverCount,
  headerStyle,
  waiverStyle
}: GuestWaiverProps) => {
  const [checkedWaivers, setCheckedWaivers] = useState<Record<string, boolean>>(
    {}
  );

  const handleCheck = (id: string) => {
    setCheckedWaivers((prevState) => {
      const updatedState = {
        ...prevState,
        [id]: !prevState[id]
      };

      const checkedCount = Object.values(updatedState).filter(Boolean).length;
      setCheckedWaiverCount(checkedCount);

      return updatedState;
    });
  };

  return (
    <FadeIn>
      <div className="relative">
        <div
          className={classnames(
            'absolute -top-8 -left-8 flex items-center',
            headerStyle
          )}
        >
          <MdArrowBack
            size="26px"
            className="text-gray-500"
            onClick={onGoBack}
          />
          <h1 className="title ml-5 mt-1">Complete Event Waivers</h1>
        </div>
        <div className="border-b-1 border-gray-200 mt-3 pt-3 -ml-11 -mr-11" />
      </div>

      <div
        className={classnames(
          '-ml-4 -mr-11 overflow-y-auto pr-6 pt-4 max-h-[82vh] md:max-h-[510px] pb-[200px]',
          waiverStyle
        )}
      >
        <div className="font-normal text-sm text-gray-500">
          Before we dive into the festivities, we kindly ask you to complete the
          following waiver to ensure a safe and enjoyable experience for
          everyone.
        </div>
        <div>
          {waivers?.map((waiver, index) => (
            <div
              key={`${waiver.content}`}
              className={`mt-4 px-4 py-4 border-1 border-gray-200 rounded-lg ${
                checkedWaivers[`waiver-${index}`] ? 'bg-primary-200' : ''
              }`}
            >
              <p className="mt-4 text-black text-sm font-medium">
                {waiver.title}
              </p>
              <p className="mt-4 font-normal text-gray-900">
                <ReactMarkdown components={{ a: linkRenderer }}>
                  {textWithMarkdown(waiver.content)}
                </ReactMarkdown>
              </p>
              <div
                className={`mt-4 px-4 py-4 flex items-center ${
                  !checkedWaivers[`waiver-${index}`]
                    ? 'bg-primary-200 border-1 border-gray-200 rounded-lg'
                    : 'border-1 border-primary-200'
                } `}
              >
                <input
                  type="checkbox"
                  id={`waiver-${index}`}
                  name="waiver"
                  value="waiver"
                  className="form-checkbox h-5 w-5 text-gray-600"
                  onChange={() => handleCheck(`waiver-${index}`)}
                  checked={checkedWaivers[`waiver-${index}`] || false}
                />
                <label
                  htmlFor={`waiver-${index}`}
                  className="ml-4 text-gray-700 text-xs "
                >
                  I accept the waiver
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>
    </FadeIn>
  );
};

export default GuestWaiver;
